module.exports = __webpack_public_path__ + "images/Media.b4d67b720ddd955e6d6aabf26386fc7b.svg";